export const STRIPE_CONFIG = {
  PUBLISHABLE_KEY:
    process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY ||
    process.env.STRIPE_PUBLISHABLE_KEY ||
    '',
  PRICING_TABLE_1_ID:
    process.env.NEXT_PUBLIC_STRIPE_PRICING_TABLE_1_ID ||
    process.env.STRIPE_PRICING_TABLE_1_ID ||
    '',
};

export const PRICING_TABLES = [
  STRIPE_CONFIG.PRICING_TABLE_1_ID, //key for table
  // STRIPE_CONFIG.PRICING_TABLE_2_ID,
];
